import { createTheme } from '@mui/material/styles';

import { customPaletteOptions } from './light';

/**
 * A slightly darker, more compact variant of the app theme.
 *
 * Built fresh in `dark` mode (so MUI generates consistent dark greys, dividers
 * and contrast text) while reusing the shared custom palette keys. Content is
 * tightened via a smaller spacing unit + dense component defaults.
 *
 * Colors/spacing here are intentionally easy to tweak.
 */
export const DarkAppTheme = createTheme({
  palette: {
    mode: 'dark',
    ...customPaletteOptions,
    // Soft dark surfaces (not pure black).
    background: {
      default: '#20242c',
      paper: '#272c36',
    },
    primary: {
      main: '#7aa2ff',
    },
  },
  // Tighter content: default spacing unit is 8 — drop it a notch.
  spacing: 6,
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontSize: 13,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h6: { fontWeight: 100 },
        h5: { fontWeight: 100 },
      },
    },
    // Denser defaults across common inputs/containers.
    MuiButton: { defaultProps: { size: 'small', disableElevation: true } },
    MuiTextField: { defaultProps: { size: 'small', margin: 'dense' } },
    MuiTable: { defaultProps: { size: 'small' } },
    MuiList: { defaultProps: { dense: true } },
    MuiToolbar: { defaultProps: { variant: 'dense' } },
  },
});
